import { Building2, Mail, Phone, MapPin, Globe, MessageSquare, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

interface LeadInformationProps {
  lead: {
    name: string;
    contactName?: string;
    contactTitle?: string;
    contactEmail?: string;
    contactPhone?: string;
    website?: string;
    address?: string;
  } | null;
}

export const LeadInformation = ({ lead }: LeadInformationProps) => {
  return (
    <div className="space-y-6">
      <Card className="p-6">
        <h2 className="mb-4 text-lg font-semibold">Lead Information</h2>
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
              <Building2 className="h-6 w-6 text-blue-600" />
            </div>
            <div>
              <h3 className="font-medium">{lead?.name || "Loading..."}</h3>
              <p className="text-sm text-gray-500">{lead?.address || "No address provided"}</p>
            </div>
          </div>

          <Separator />

          <div className="space-y-3">
            <h3 className="text-sm font-medium">Contact Information</h3>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-gray-700">
                <Users className="h-4 w-4 text-gray-400" />
                <span>
                  {lead?.contactName || "No contact"}{" "}
                  {lead?.contactTitle ? `- ${lead.contactTitle}` : ""}
                </span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <Mail className="h-4 w-4 text-gray-400" />
                <a
                  href={`mailto:${lead?.contactEmail || ""}`}
                  className="text-blue-600 hover:underline"
                >
                  {lead?.contactEmail || "No email provided"}
                </a>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <Phone className="h-4 w-4 text-gray-400" />
                <span>{lead?.contactPhone || "No phone provided"}</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <Globe className="h-4 w-4 text-gray-400" />
                {lead?.website ? (
                  <a
                    href={
                      lead.website.startsWith("http") ? lead.website : `https://${lead.website}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    {lead.website}
                  </a>
                ) : (
                  <span className="text-gray-500">No website provided</span>
                )}
              </div>
            </div>
          </div>

          <Button variant="outline" className="w-full gap-2">
            <MessageSquare className="h-4 w-4" /> Contact Lead
          </Button>
        </div>
      </Card>
    </div>
  );
};
